import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucidePanelLeft = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <rect width={18} height={18} x={3} y={3} rx={2} />
      <path d="M9 3v18" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucidePanelLeft);
const Memo = memo(ForwardRef);
export default Memo;
